import { useGradientId } from '@internal/plugin-waadoo-core';

/**
 * The way into an environment's Odoo instance, its web address (the icons
 * registry's `odoo-instance` key): a blue globe, with a white badge carrying
 * an « open » arrow ↗ — a page of the web, opened elsewhere.
 *
 * In colour, like the terminal icons (terminalIcons.tsx) and the official
 * logos it sits next to (Grafana on the home page's project cards), and drawn
 * the same way: inline, on a 24x24 viewBox, 1em, decorative, with fixed
 * colours and never `currentColor`, so the link around it does not recolour
 * it. Not `login`, which is signing in to Backstage (the sign-in page).
 */
export function OdooInstanceIcon() {
  const gradientId = useGradientId('waadoo-odoo-instance-gradient');
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#38bdf8" />
          <stop offset="1" stopColor="#2563eb" />
        </linearGradient>
      </defs>
      <circle cx="11" cy="13" r="9" fill={`url(#${gradientId})`} />
      {/* A meridian and three parallels. */}
      <g fill="none" stroke="#fff" strokeWidth="1.4">
        <ellipse cx="11" cy="13" rx="3.8" ry="9" />
        <path d="M2.2 13h17.6M3.6 8.5h14.8M3.6 17.5h14.8" />
      </g>
      {/* The badge, over the globe's top right, and its ↗ arrow. */}
      <circle cx="19" cy="5" r="4.6" fill="#fff" />
      <path
        d="M17.2 6.8l3.4-3.4M18.1 3.4h2.5v2.5"
        fill="none"
        stroke="#2563eb"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
